/* pz3-pagina.js · Pozzalume, opzione 3 "Teatrino di carta", portata nel tema (P1-PORTA3, P2-VIVA)
   Dall'originale (OPZ3/pagina.js, poi VIVA/pagina.js): la firma (ritaglia lungo il tratteggio e il pezzo vero si alza in piedi),
   le creature da fare amiche con tre scintille, il dado col 6 d'oro, il sentiero delle sere, l'assaggio da sfogliare,
   i pezzi che restano in piedi sul palco finale, la barra al telefono, le rivelazioni e i suoni spenti all'arrivo.
   P2-VIVA: le ricette di pz3-musica.js (window.PzMusica) entrano nella tavolozza di suoni.js, con l'ambiente 'colonna'
   (la colonna sonora per zone, che nasce solo quando chi guarda accende i suoni); la creatura amica suona; il Musone del
   diorama sale e scende con le sue scariche.
   Tolti dall'originale: il carrello finto (quello vero e' di pozzalume.js) e la merenda dei cookie (c'e' base-consent).
   Portati da pz-pagina.js: la barra della scheda, il 404, il recesso, il comando che ferma il movimento, la resa.
   Nessun testo scritto qui: ogni parola arriva dalla pagina (attributi data-* riempiti dai file di lingua).
   Senza questo file, o con movimento ridotto, tutto e' gia' in piedi e leggibile, e i bottoni restano moduli veri. */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  w.__pozzalume = true; // la pagina e' viva: le rivelazioni possono restare (vedi lo script in testa)
  var resa = html.classList.contains('resa');
  var inPausa = false;
  var ridotto = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var A = w.anime || null;
  var conTimeline = !!(w.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function fuoco(el) { if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } } }
  function leggi(arch, k) { try { return w[arch].getItem(k); } catch (e) { return null; } }
  function scrivi(arch, k, v) { try { w[arch].setItem(k, v); } catch (e) { /* senza memoria la pagina funziona lo stesso */ } }

  /* =========================================================
     Suoni: forbici, matita, piega e la firma sono ricette; il foglio e il gettone sono file CC0 (Kenney)
     ========================================================= */
  var R = {};
  function inizio(ctx, p) { return ctx.currentTime + ((p && p.ritardo) || 0); }
  function forza(p) { return p && p.volume != null ? p.volume : 1; }
  function tono(p) { return (p && p.tono) || 1; }
  function soffio(ctx, t, durata) {
    var s = ctx.createBufferSource();
    s.buffer = w.Suoni.rumore(ctx);
    s.start(t, Math.random() * 1.4);
    s.stop(t + durata);
    return s;
  }

  // forbici: le lame che scorrono, poi il piccolo clic d'acciaio quando si chiudono
  R.forbici = function (ctx, out, p) {
    var t = inizio(ctx, p), v = forza(p), k = tono(p);
    var n = soffio(ctx, t, 0.075), bp = ctx.createBiquadFilter(), g = ctx.createGain();
    bp.type = 'bandpass'; bp.Q.value = 1.4;
    bp.frequency.setValueAtTime(6200 * k, t);
    bp.frequency.exponentialRampToValueAtTime(3600 * k, t + 0.05);
    w.Suoni.inviluppo(g.gain, t, 0.85 * v, 0.004, 0.045);
    n.connect(bp); bp.connect(g); g.connect(out);
    var tc = t + 0.048;
    var n2 = soffio(ctx, tc, 0.03), hp = ctx.createBiquadFilter(), g2 = ctx.createGain();
    hp.type = 'highpass'; hp.frequency.value = 2800 * k;
    w.Suoni.inviluppo(g2.gain, tc, 0.6 * v, 0.001, 0.014);
    n2.connect(hp); hp.connect(g2); g2.connect(out);
    var o = ctx.createOscillator(), go = ctx.createGain();
    o.type = 'sine'; o.frequency.setValueAtTime(3150 * k, tc);
    w.Suoni.inviluppo(go.gain, tc, 0.07 * v, 0.001, 0.05);
    o.connect(go); go.connect(out); o.start(tc); o.stop(tc + 0.07);
    return 0.13;
  };

  // matita: una spunta sul foglio, tratto corto in giu' e tratto lungo in su
  R.matita = function (ctx, out, p) {
    var t = inizio(ctx, p), v = forza(p), k = tono(p);
    [[0, 0.06, 0.8], [0.08, 0.15, 1]].forEach(function (s) {
      var ts = t + s[0], dur = s[1];
      var n = soffio(ctx, ts, dur + 0.03), hp = ctx.createBiquadFilter(), bp = ctx.createBiquadFilter(), g = ctx.createGain();
      hp.type = 'highpass'; hp.frequency.value = 900;
      bp.type = 'bandpass'; bp.Q.value = 1.1;
      bp.frequency.setValueAtTime(2000 * k, ts);
      bp.frequency.linearRampToValueAtTime(3000 * k, ts + dur);
      g.gain.setValueAtTime(0.0001, ts);
      var colpi = Math.max(4, Math.round(dur / 0.014));
      for (var i = 0; i < colpi; i++) {
        var ti = ts + i * dur / colpi + Math.random() * 0.003;
        var a = (0.62 + Math.random() * 0.9) * v * s[2] * Math.sin(Math.PI * (i + 0.5) / colpi);
        g.gain.setValueAtTime(0.0001, ti);
        g.gain.exponentialRampToValueAtTime(Math.max(a, 0.0002), ti + 0.002);
        g.gain.exponentialRampToValueAtTime(0.0001, ti + 0.01);
      }
      n.connect(hp); hp.connect(bp); bp.connect(g); g.connect(out);
    });
    return 0.27;
  };

  // piega: il cartoncino che si alza (un soffio che sale) e si posa (un tocco morbido)
  R.piega = function (ctx, out, p) {
    var t = inizio(ctx, p), v = forza(p), k = tono(p);
    var n = soffio(ctx, t, 0.2), bp = ctx.createBiquadFilter(), g = ctx.createGain();
    bp.type = 'bandpass'; bp.Q.value = 1.0;
    bp.frequency.setValueAtTime(800 * k, t);
    bp.frequency.exponentialRampToValueAtTime(2600 * k, t + 0.14);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.74 * v, t + 0.08);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.18);
    n.connect(bp); bp.connect(g); g.connect(out);
    var tp = t + 0.16, n2 = soffio(ctx, tp, 0.09), bp2 = ctx.createBiquadFilter(), g2 = ctx.createGain();
    bp2.type = 'bandpass'; bp2.frequency.value = 560 * k; bp2.Q.value = 1.4;
    w.Suoni.inviluppo(g2.gain, tp, 1.05 * v, 0.003, 0.06);
    n2.connect(bp2); bp2.connect(g2); g2.connect(out);
    return 0.27;
  };

  // la firma sonora: due colpi di forbici, il pezzo che si alza, tre note di carillon (sol, do, mi)
  R.firma = function (ctx, out, p) {
    var r = (p && p.ritardo) || 0, v = forza(p);
    R.forbici(ctx, out, { ritardo: r, volume: 0.58 * v, tono: 1 });
    R.forbici(ctx, out, { ritardo: r + 0.15, volume: 0.58 * v, tono: 1.05 });
    R.piega(ctx, out, { ritardo: r + 0.32, volume: 0.66 * v, tono: 1 });
    [783.99, 1046.5, 1318.51].forEach(function (f, i) {
      w.Suoni.ricette.carillon(ctx, out, { nota: f, ritardo: r + 0.52 + i * 0.18, volume: 0.6 * v, lunghezza: 0.5 });
    });
    return r + 0.88 + 0.83;
  };

  var S = null;
  if (w.Suoni) {
    // la colonna sonora e le voci dei personaggi vengono da musica.js
    var M = w.PzMusica && w.PzMusica.ricette;
    if (M) Object.keys(M).forEach(function (k) { if (!R[k]) R[k] = M[k]; });
    S = w.Suoni.crea({
      conferma: 'firma',
      volume: 0.8,
      ambiente: M ? 'colonna' : null,
      volumeAmbiente: 0.5,
      file: { foglio: d.body.getAttribute('data-suono-file-foglio'), gettone: d.body.getAttribute('data-suono-file-gettone') },
      ricette: R
    });
    S.alVedere('.mazzo', 'piega');
    S.alVedere('.tavolo', 'foglio');
    S.alVedere('.offerta__griglia', 'piega');
    // il resto della tavolozza suona ai gesti; a suoni spenti suona() non fa rumore e segna solo il nome,
    // cosi' la tavolozza dichiarata e' intera fin dall'arrivo
    ['forbici', 'matita', 'gettone'].concat(M ? ['torta', 'saltello', 'musone', 'mulinello', 'amica', 'lanterna', 'festa', 'russa', 'naso', 'luna'] : []).forEach(function (n) { S.suona(n); });
  }
  // la voce della pagina: ogni suono passa da qui (e il collaudo lo legge per nome)
  var voce = { suona: function (nome, p) { if (S) S.suona(nome, p); } };
  w.eroiVoce = voce; // EROI-CONTENUTI-2: la ruota del kit (eroi-racconto.js) suona con la stessa voce

  /* =========================================================
     La firma: ritaglia lungo il tratteggio, il pezzo vero si alza
     ========================================================= */
  var pezzi = $$('.pezzo');
  var tagliati = 0;
  var memoriaTagli = {};
  try { memoriaTagli = JSON.parse(leggi('sessionStorage', 'pozzalume-tagli') || '{}') || {}; } catch (e) { memoriaTagli = {}; }
  function ricordaTaglio(nome) { memoriaTagli[nome] = 1; scrivi('sessionStorage', 'pozzalume-tagli', JSON.stringify(memoriaTagli)); }
  function prossimoDaTagliare() {
    for (var i = 0; i < pezzi.length; i++) if (pezzi[i].getAttribute('data-stato') !== 'in-piedi') return pezzi[i];
    return null;
  }
  // il pezzo gemello sul palco finale: quando lo ritagliate qui, la' e' gia' in piedi
  function alzaMini(nome, conMolla) {
    var m = $('[data-mini="' + nome + '"]');
    if (!m || m.getAttribute('data-stato') === 'in-piedi') return;
    m.setAttribute('data-stato', 'in-piedi');
    var b = $('.mini__forbici', m); if (b) b.tabIndex = -1;
    var sag = $('.mini__sagoma', m);
    if (conMolla && !ridotto && A && A.animate && sag) {
      var molla = { rotateX: [70, 0] };
      if (A.spring) molla.ease = A.spring({ stiffness: 170, damping: 9 }); else { molla.ease = 'out(3)'; molla.duration = 600; }
      sag.style.transition = 'none';
      A.animate(sag, molla);
    }
  }
  pezzi.forEach(function (p) {
    var nome = p.getAttribute('data-pezzo');
    var striscia = $('[data-taglio]', p), forb = $('.forbici', p), fatto = $('.taglio__fatto', p), sag = $('.pezzo__sagoma', p);
    var gettoni = $$('.inventario .gettone', p);
    var prog = 0, attivo = false, mosso = false, x0 = 0, y0 = 0, finito = false, inCorsa = false, ultimoSnip = 0, colpi = 0;
    if (!striscia || !forb || !sag) return;
    if (ridotto || memoriaTagli[nome]) { p.setAttribute('data-stato', 'in-piedi'); forb.tabIndex = -1; tagliati++; alzaMini(nome, false); finito = true; return; }

    function misura() { var r = striscia.getBoundingClientRect(); return { l: r.left + 28, w: Math.max(1, r.width - 56) }; }
    function disegna() {
      var m = misura();
      forb.style.transform = 'translateX(' + (prog * m.w).toFixed(1) + 'px)';
      fatto.style.transform = 'scaleX(' + prog.toFixed(3) + ')';
      if (!finito) sag.style.transform = 'rotateX(' + (66 - prog * 14).toFixed(2) + 'deg)';
    }
    function snip() {
      forb.classList.add('chiude');
      setTimeout(function () { forb.classList.remove('chiude'); }, 100);
      colpi++;
      if (colpi % 2 === 1) voce.suona('forbici', { intervallo: 190 });
    }
    function alzati() {
      if (finito) return;
      finito = true; inCorsa = false;
      p.setAttribute('data-stato', 'in-piedi');
      p.classList.remove('invito');
      ricordaTaglio(nome);
      alzaMini(nome, false);
      var da = 66 - prog * 14;
      voce.suona('piega');
      if (A && A.animate) {
        var molla = { rotateX: [da, 0] };
        if (A.spring) molla.ease = A.spring({ stiffness: 170, damping: 9 }); else { molla.ease = 'out(3)'; molla.duration = 600; }
        A.animate(sag, molla);
        A.animate(gettoni, { scale: [0.78, 1], delay: A.stagger ? A.stagger(70, { start: 240 }) : 240, duration: 700, ease: 'outElastic(1, .55)' });
      } else {
        sag.style.transform = 'none';
      }
      tagliati++;
      if (tagliati === pezzi.length) setTimeout(function () { voce.suona('firma'); }, 650);
      var aveva = d.activeElement === forb;
      forb.tabIndex = -1;
      if (aveva) {
        var dopo = prossimoDaTagliare();
        fuoco(dopo ? $('.forbici', dopo) : $('.kit__tesoro [data-pz-aggiungi]'));
      }
    }
    function auto() {
      if (finito || inCorsa) return;
      inCorsa = true;
      p.classList.remove('invito');
      var da = prog, ta = performance.now(), dur = 720 * (1 - da) + 120;
      (function passo(t) {
        var k = Math.min(1, Math.max(0, (t - ta) / dur));
        prog = da + (1 - da) * (1 - Math.pow(1 - k, 2));
        if (t - ultimoSnip > 140) { snip(); ultimoSnip = t; }
        disegna();
        if (k < 1) requestAnimationFrame(passo); else alzati();
      })(ta);
    }
    striscia.addEventListener('pointerdown', function (e) {
      if (finito || inCorsa) return;
      attivo = true; mosso = false; x0 = e.clientX; y0 = e.clientY;
      p.classList.remove('invito');
      try { striscia.setPointerCapture(e.pointerId); } catch (er) {}
    });
    striscia.addEventListener('pointermove', function (e) {
      if (!attivo || finito || inCorsa) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (!mosso) {
        if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { attivo = false; return; }
        if (Math.abs(dx) <= 6) return;
        mosso = true;
      }
      var m = misura(), nuovo = Math.max(0, Math.min(1, (e.clientX - m.l) / m.w));
      if (nuovo > prog) {
        prog = nuovo;
        var t = performance.now();
        if (t - ultimoSnip > 90) { snip(); ultimoSnip = t; }
      }
      disegna();
      if (prog >= 0.82) { attivo = false; auto(); }
    });
    // un tocco senza trascinare: le forbici tagliano da sole (anche se il clic arriva tardi o non arriva)
    striscia.addEventListener('pointerup', function () {
      var eraAttivo = attivo;
      attivo = false;
      if (eraAttivo && !mosso) auto();
    });
    striscia.addEventListener('pointercancel', function () { attivo = false; mosso = false; });
    striscia.addEventListener('click', function () {
      if (mosso) { mosso = false; return; }
      auto();
    });
    w.addEventListener('resize', function () { if (!finito) disegna(); }, { passive: true });
    disegna();
  });

  // i pezzi del palco finale si possono ritagliare anche li', con un tocco sulle forbici
  $$('[data-mini]').forEach(function (m) {
    var b = $('.mini__forbici', m), nome = m.getAttribute('data-mini');
    if (ridotto) { m.setAttribute('data-stato', 'in-piedi'); if (b) b.tabIndex = -1; return; }
    if (b) b.addEventListener('click', function () {
      voce.suona('forbici');
      setTimeout(function () { voce.suona('piega'); }, 160);
      ricordaTaglio(nome);
      alzaMini(nome, true);
      var grande = $('.pezzo[data-pezzo="' + nome + '"]');
      if (grande && grande.getAttribute('data-stato') !== 'in-piedi') { grande.setAttribute('data-stato', 'in-piedi'); var fb = $('.forbici', grande); if (fb) fb.tabIndex = -1; var sg = $('.pezzo__sagoma', grande); if (sg) sg.style.transform = 'none'; var ft = $('.taglio__fatto', grande); if (ft) ft.style.transform = 'scaleX(1)'; if (fb) fb.style.transform = ''; tagliati++; }
      var prossimo = $('[data-mini][data-stato="steso"] .mini__forbici');
      fuoco(prossimo || $('.bundle [data-pz-aggiungi]'));
    });
  });

  // invito: se il kit resta in vista e nessuno taglia, le prime forbici fanno due scatti
  if (!ridotto && pezzi[0] && 'IntersectionObserver' in w) {
    var attesa = null, invitato = false;
    var ioInvito = new IntersectionObserver(function (voci) {
      voci.forEach(function (x) {
        if (x.isIntersecting && !invitato) {
          clearTimeout(attesa);
          attesa = setTimeout(function () {
            if (tagliati === 0 && pezzi[0].getAttribute('data-stato') === 'steso') {
              invitato = true;
              pezzi[0].classList.add('invito');
              setTimeout(function () { pezzi[0].classList.remove('invito'); }, 2900);
              ioInvito.disconnect();
            }
          }, 2500);
        } else if (!x.isIntersecting) { clearTimeout(attesa); }
      });
    }, { threshold: 0.6 });
    ioInvito.observe(pezzi[0]);
  }

  /* =========================================================
     Le creature della sera: tre scintille e diventa amica (la carta si gira)
     ========================================================= */
  function giraCarta(c, avanti) {
    var fronte = $('.creatura__fronte', c), retro = $('.creatura__retro', c);
    var dentro = c.contains(d.activeElement);
    c.classList.toggle('girata', avanti);
    fronte.inert = avanti; retro.inert = !avanti;
    voce.suona('piega', { tono: avanti ? 1 : 0.92 });
    if (dentro) fuoco(avanti ? $('.creatura__torna', c) : $('.casella', c));
  }
  $$('[data-creatura]').forEach(function (c) {
    var caselle = $$('.casella', c), torna = $('.creatura__torna', c), retro = $('.creatura__retro', c);
    var gira = !ridotto;
    if (gira && retro) retro.inert = true;
    caselle.forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) voce.suona('matita');
        var tutte = caselle.every(function (x) { return x.getAttribute('aria-pressed') === 'true'; });
        if (tutte && c.getAttribute('data-amica') !== '1') {
          c.setAttribute('data-amica', '1');
          voce.suona('amica', { ritardo: 0.12 });
          if (gira) setTimeout(function () { giraCarta(c, true); }, 520);
        } else if (!tutte && c.getAttribute('data-amica') === '1') {
          c.setAttribute('data-amica', '0');
        }
      });
    });
    if (torna) torna.addEventListener('click', function () { giraCarta(c, false); });
  });

  /* =========================================================
     Il dado del gioco: con il 6 ce la fai sempre; se non esce, una scintilla (al massimo 3)
     ========================================================= */
  var dado = $('[data-dado]'), tiraB = $('[data-tira]'), esito = $('[data-esito]'), posti = $$('[data-scintille] .scintilla-posto');
  if (dado && tiraB) {
    // i testi li scrive Liquid sul riquadro del tiro (pz3.gentile): {n} e {tot} si riempiono qui
    var tiroBox = dado.closest('.tiro');
    var testoTiro = function (k, v) { var t = (tiroBox && tiroBox.getAttribute('data-testo-' + k)) || ''; return t.replace(/\{(\w+)\}/g, function (m, x) { return v[x] != null ? String(v[x]) : m; }); };
    var pose = { 1: [0, 0], 6: [0, 180], 2: [0, -90], 5: [0, 90], 3: [-90, 0], 4: [90, 0] };
    var giri = 0, scintille = 0, girando = false;
    var mostraFaccia = function (n, anim) {
      var q = pose[n];
      giri += 1;
      var t = 'rotateX(-20deg) rotateY(-28deg) rotateX(' + (q[0] + giri * 360) + 'deg) rotateY(' + (q[1] + giri * 360) + 'deg)';
      dado.style.transition = anim ? 'transform 1.1s cubic-bezier(.2,.8,.25,1.08)' : 'none';
      dado.style.transform = t;
    };
    tiraB.addEventListener('click', function () {
      if (girando) return;
      girando = true;
      var n = 1 + Math.floor(Math.random() * 6);
      voce.suona('dado');
      mostraFaccia(n, !ridotto && !inPausa);
      setTimeout(function () {
        girando = false;
        if (n === 6) {
          esito.innerHTML = testoTiro('sei', {});
          voce.suona('sei');
        } else {
          if (scintille >= posti.length) { scintille = 0; posti.forEach(function (x) { x.classList.remove('piena'); }); }
          posti[scintille].classList.add('piena');
          scintille++;
          esito.innerHTML = testoTiro('non-ancora', { n: n });
          voce.suona('matita', { tono: 1.15 });
        }
        if (posti.length) posti[0].parentNode.setAttribute('aria-label', testoTiro('scintille', { n: scintille, tot: posti.length }));
      }, ridotto || inPausa ? 0 : 1050);
    });
  }

  /* =========================================================
     Il sentiero delle sere: la traccia unisce le caselle vere, l'eroe cammina fino a quella toccata
     ========================================================= */
  var sentiero = $('[data-sentiero]');
  if (sentiero) {
    var caselleS = $$('.tappa__casella', sentiero), viandante = $('[data-viandante]', sentiero), tracce = $$('.sentiero__traccia path', sentiero), svgS = $('.sentiero__traccia', sentiero);
    var qui = 0;
    var centri = function () {
      var r0 = sentiero.getBoundingClientRect();
      return caselleS.map(function (c) { var r = c.getBoundingClientRect(); return [r.left - r0.left + r.width / 2, r.top - r0.top + r.height / 2, r.width]; });
    };
    var traccia = function () {
      var c = centri(), wS = sentiero.clientWidth, hS = sentiero.clientHeight;
      if (!c.length) return;
      svgS.setAttribute('viewBox', '0 0 ' + wS + ' ' + hS);
      svgS.setAttribute('preserveAspectRatio', 'none');
      var dd = 'M' + c[0][0].toFixed(1) + ' ' + c[0][1].toFixed(1);
      for (var i = 1; i < c.length; i++) {
        var a = c[i - 1], b = c[i], my = (a[1] + b[1]) / 2;
        dd += ' C ' + a[0].toFixed(1) + ' ' + my.toFixed(1) + ', ' + b[0].toFixed(1) + ' ' + my.toFixed(1) + ', ' + b[0].toFixed(1) + ' ' + b[1].toFixed(1);
      }
      tracce.forEach(function (p) { p.setAttribute('d', dd); });
      posa(qui, false);
    };
    var posa = function (i, anim) {
      if (!viandante) return;
      var c = centri()[i]; if (!c) return;
      var hV = viandante.offsetHeight || 78, wV = viandante.offsetWidth || 50;
      // l'eroe si ferma in piedi sul bordo basso della casella, dalla parte del sentiero
      var x = c[0] + c[2] * 0.18, y = c[1] + c[2] / 2 - hV + 4;
      if (i % 2 === 1) x = c[0] - c[2] * 0.18 - wV;
      viandante.style.transition = anim && !ridotto ? 'transform .95s cubic-bezier(.45,.05,.3,1)' : 'none';
      viandante.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      if (anim && !ridotto) { viandante.classList.remove('cammina'); void viandante.offsetWidth; viandante.classList.add('cammina'); }
    };
    caselleS.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        caselleS.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) { qui = i; posa(i, true); voce.suona('matita', { tono: 1.1 }); }
      });
    });
    var rqS = 0;
    w.addEventListener('resize', function () { if (!rqS) rqS = requestAnimationFrame(function () { rqS = 0; traccia(); }); }, { passive: true });
    if (viandante && !viandante.complete) viandante.addEventListener('load', function () { posa(qui, false); });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(traccia);
    traccia();
  }

  /* =========================================================
     L'assaggio: una pila di pagine vere da sfogliare, col bottone o col dito
     ========================================================= */
  var pila = $('[data-pila]');
  if (pila) {
    var fogli = $$('.foglio', pila), ordine = fogli.map(function (f, i) { return i; }), pagina = 1, occupato = false;
    var conto = $('[data-pagina]'), sfogliaB = $('[data-sfoglia]'), didascalia = $('[data-didascalia]:not(.foglio)');
    var disponi = function (fermi) {
      ordine.forEach(function (i, pos) {
        var f = fogli[i];
        if (fermi) f.classList.add('senza-moto');
        f.style.setProperty('--k', pos);
        f.classList.toggle('cima', pos === 0);
      });
      if (fermi) { void pila.offsetWidth; fogli.forEach(function (f) { f.classList.remove('senza-moto'); }); }
      if (didascalia) didascalia.innerHTML = fogli[ordine[0]].getAttribute('data-didascalia');
    };
    var sfoglia = function (verso) {
      if (occupato) return;
      occupato = true;
      var cima = fogli[ordine[0]];
      voce.suona('foglio');
      pagina = pagina % fogli.length + 1;
      if (conto) conto.textContent = pagina;
      var chiudi = function (anim) {
        cima.classList.add('senza-moto');
        cima.style.translate = ''; cima.style.rotate = '';
        ordine.push(ordine.shift());
        disponi(false);
        void cima.offsetWidth;
        if (anim) anim.cancel();
        cima.classList.remove('senza-moto');
        if (!ridotto && cima.animate) cima.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, easing: 'ease-out' });
        occupato = false;
      };
      if (ridotto || !cima.animate) { chiudi(null); return; }
      var dir = verso || 1;
      var anim = cima.animate([
        { transform: 'none', opacity: 1 },
        { transform: 'translate(' + (dir * 118) + '%, -7%) rotate(' + (dir * 17) + 'deg)', opacity: 0 }
      ], { duration: 430, easing: 'cubic-bezier(.45,0,.8,.45)', fill: 'forwards' });
      anim.onfinish = function () { chiudi(anim); };
    };
    disponi(true);
    if (sfogliaB) sfogliaB.addEventListener('click', function () { sfoglia(1); });
    var px = 0, py = 0, preso = false, mossoP = false, dxP = 0;
    pila.addEventListener('pointerdown', function (e) {
      if (occupato) return;
      preso = true; mossoP = false; px = e.clientX; py = e.clientY; dxP = 0;
    });
    pila.addEventListener('pointermove', function (e) {
      if (!preso) return;
      var mx = e.clientX - px, my = e.clientY - py;
      if (!mossoP) {
        if (Math.abs(my) > 12 && Math.abs(my) > Math.abs(mx)) { preso = false; return; }
        if (Math.abs(mx) <= 6) return;
        mossoP = true;
        pila.classList.add('trascina');
        try { pila.setPointerCapture(e.pointerId); } catch (er) {}
      }
      dxP = mx;
      var cima = fogli[ordine[0]];
      cima.classList.add('senza-moto');
      cima.style.translate = mx.toFixed(1) + 'px ' + (my * 0.15).toFixed(1) + 'px';
      cima.style.rotate = (mx * 0.05 - 2.2).toFixed(2) + 'deg';
    });
    var lascia = function (annulla) {
      if (!preso) return;
      preso = false;
      if (!mossoP) return;
      pila.classList.remove('trascina');
      var cima = fogli[ordine[0]];
      cima.classList.remove('senza-moto');
      if (!annulla && Math.abs(dxP) > 60) sfoglia(dxP > 0 ? 1 : -1);
      else { cima.style.translate = ''; cima.style.rotate = ''; }
    };
    pila.addEventListener('pointerup', function () { lascia(false); });
    pila.addEventListener('pointercancel', function () { lascia(true); });
    pila.addEventListener('click', function (e) { if (mossoP) { mossoP = false; e.preventDefault(); } });
  }

  /* =========================================================
     Il carrello vero e' di pozzalume.js (cassetto #pz-cassetto, evento pz:carrello): qui solo il gesto.
     Al clic su un bottone d'acquisto la scintilla vola nella borsa, suona il gettone e la borsa si scuote;
     il clic passa intatto a pozzalume.js, che mette il gioco nel carrello e apre il cassetto.
     ========================================================= */
  var apriB = $('.testata [data-pz-apri-carrello]'), volo = $('[data-volo]'), cassetto = $('#pz-cassetto');
  function scuoti() {
    if (!apriB) return;
    apriB.classList.remove('scossa'); void apriB.offsetWidth; apriB.classList.add('scossa');
  }
  function puntiArco(x0, y0, x1, y1, n) {
    var cx = (x0 + x1) / 2, cy = Math.min(y0, y1) - Math.max(90, Math.abs(x1 - x0) * 0.25), out = [];
    for (var i = 0; i <= n; i++) {
      var t = i / n, u = 1 - t;
      out.push([u * u * x0 + 2 * u * t * cx + t * t * x1, u * u * y0 + 2 * u * t * cy + t * t * y1]);
    }
    return out;
  }
  function vola(bottone) {
    if (!bottone || bottone.disabled) return;
    var nelCassetto = cassetto && cassetto.contains(bottone);
    var visibileB = apriB && apriB.getBoundingClientRect().width > 0;
    if (ridotto || inPausa || nelCassetto || !volo || !volo.animate || !visibileB) {
      voce.suona('gettone');
      if (!nelCassetto) scuoti();
      return;
    }
    var a = bottone.getBoundingClientRect(), bb = apriB.getBoundingClientRect();
    var pts = puntiArco(a.left + a.width / 2 - 14, a.top + a.height / 2 - 14, bb.left + bb.width / 2 - 14, bb.top + bb.height / 2 - 14, 14);
    var fot = pts.map(function (q, i) {
      var t = i / (pts.length - 1);
      var sc = t < 0.15 ? 0.6 + t / 0.15 * 0.55 : 1.15 - (t - 0.15) / 0.85 * 0.5;
      return { transform: 'translate(' + q[0].toFixed(1) + 'px,' + q[1].toFixed(1) + 'px) rotate(' + Math.round(t * 400) + 'deg) scale(' + sc.toFixed(2) + ')', opacity: t < 0.08 ? t / 0.08 : (t > 0.94 ? (1 - t) / 0.06 : 1) };
    });
    volo.animate(fot, { duration: 640, easing: 'cubic-bezier(.4,.05,.45,1)' });
    voce.suona('gettone', { ritardo: 0.6 });
    setTimeout(scuoti, 600);
  }
  // in cattura: parte prima di pozzalume.js e non blocca niente
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-pz-aggiungi]') : null;
    if (b && !b.closest('form[data-pz-scelta]')) vola(b);
  }, true);
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[data-pz-scelta]')) vola(e.submitter || $('[type="submit"]', f));
  }, true);
  // la borsa fa il suo piccolo salto quando il conteggio cambia davvero
  d.addEventListener('pz:carrello', function (e) {
    var det = e.detail || {};
    if (!det.conteggio || ridotto || inPausa) return;
    $$('[data-pz-contatore]').forEach(function (c) { c.classList.remove('is-salto'); void c.offsetWidth; c.classList.add('is-salto'); });
  });

  /* ---------- barra al telefono ---------- */
  // home: quando ne' la prima schermata ne' l'offerta sono in vista; scheda: quando il bottone del modulo e' uscito sopra.
  // Col cassetto aperto la barra se ne va.
  var mq = w.matchMedia ? w.matchMedia('(max-width: 799px)') : null;
  function cassettoAperto() { return !!(cassetto && cassetto.open); }
  function mostraBarra(barra, mostra) {
    if (mostra) {
      if (barra.hidden) { barra.hidden = false; void barra.offsetWidth; }
      barra.classList.add('su');
      barra.inert = false; barra.removeAttribute('inert'); barra.setAttribute('aria-hidden', 'false');
    } else {
      barra.classList.remove('su');
      barra.inert = true; barra.setAttribute('inert', ''); barra.setAttribute('aria-hidden', 'true');
    }
  }
  var barraHome = $('[data-barra]'), barraScheda = $('[data-barra-scheda]'), aggiornaBarra = function () {};
  if (barraHome && !resa && 'IntersectionObserver' in w) {
    var inVista = { palco: true, offerta: false };
    aggiornaBarra = function () { mostraBarra(barraHome, !!(mq && mq.matches) && !inVista.palco && !inVista.offerta && !cassettoAperto()); };
    var cartaPalco = $('.palco__carta'), griglia = $('.offerta__griglia');
    var ioBarra = new IntersectionObserver(function (voci) {
      voci.forEach(function (x) {
        if (x.target === cartaPalco) inVista.palco = x.isIntersecting;
        if (x.target === griglia) inVista.offerta = x.isIntersecting;
      });
      aggiornaBarra();
    });
    if (cartaPalco) ioBarra.observe(cartaPalco);
    if (griglia) ioBarra.observe(griglia);
  } else if (barraScheda && !resa && 'IntersectionObserver' in w) {
    var DATI = {};
    try { DATI = JSON.parse(($('#pz-dati') || {}).textContent || '{}') || {}; } catch (e) { DATI = {}; }
    var bottoneB = $('[data-pz-aggiungi]', barraScheda), fuoriVista = false;
    // la barra segue l'edizione scelta nelle radio del modulo: bottone, variante vera, disponibilita', nome e prezzo
    var seguiRadio = function () {
      var r = $('form[data-pz-scelta] input[name="id"][data-pz-ed]:checked');
      var ed = r && r.getAttribute('data-pz-ed');
      if ((ed !== 'base' && ed !== 'completo') || !bottoneB) return;
      var v = DATI[ed];
      bottoneB.setAttribute('data-pz-aggiungi', ed);
      var campo = bottoneB.form ? $('input[name="id"]', bottoneB.form) : null;
      if (campo && v && v.id != null) campo.value = String(v.id);
      if (v) bottoneB.disabled = v.disponibile === false;
      var bn = $('[data-barra-nome]', barraScheda), bp = $('[data-barra-prezzo]', barraScheda);
      if (bn) { var nome = bn.getAttribute('data-nome-' + ed); if (nome) bn.textContent = nome; }
      if (bp && v && v.prezzo) bp.textContent = String(v.prezzo);
      var bb = $('[data-barra-barrato]', barraScheda);
      if (bb && v) {
        bb.textContent = '';
        if (v.barrato) { var s = d.createElement('s'); s.className = 'barrato'; s.setAttribute('aria-hidden', 'true'); s.textContent = String(v.barrato); bb.appendChild(s); }
      }
    };
    $$('form[data-pz-scelta] input[name="id"][data-pz-ed]').forEach(function (r) { r.addEventListener('change', seguiRadio); });
    seguiRadio();
    aggiornaBarra = function () { mostraBarra(barraScheda, !!(mq && mq.matches) && fuoriVista && !cassettoAperto()); };
    var compraScheda = $('form[data-pz-scelta] [type="submit"]');
    // la barra c'e' ogni volta che il bottone vero non si vede: all'arrivo (al telefono sta sotto la galleria) e dopo
    if (compraScheda) new IntersectionObserver(function (voci) {
      var v = voci[voci.length - 1];
      fuoriVista = !v.isIntersecting;
      aggiornaBarra();
    }).observe(compraScheda);
  }
  if (mq) { if (mq.addEventListener) mq.addEventListener('change', function () { aggiornaBarra(); }); else if (mq.addListener) mq.addListener(function () { aggiornaBarra(); }); }
  if (cassetto && 'MutationObserver' in w) new MutationObserver(function () { aggiornaBarra(); }).observe(cassetto, { attributes: true, attributeFilter: ['open'] });

  /* ---------- al telefono l'elenco di ogni gioco si apre a richiesta: cosi' i due prezzi si vedono insieme ---------- */
  if (!resa && mq && mq.matches) $$('[data-dentro]').forEach(function (x) { x.open = false; });

  /* ---------- 404: il percorso cercato ---------- */
  var cercata = $('[data-pz-cercata]');
  if (cercata) {
    var percorso = w.location.pathname, spanC = $('span', cercata);
    try { percorso = decodeURI(percorso); } catch (e) {}
    if (percorso.length > 48) percorso = percorso.slice(0, 47) + '…';
    if (spanC && percorso && percorso !== '/404') { spanC.textContent = percorso; cercata.hidden = false; }
  }

  /* ---------- recesso: il bottone apre la dichiarazione; il secondo passo e' nel modulo ---------- */
  var apriRecesso = $('[data-pz-recesso-apri]'), corpoRecesso = $('#pz-recesso-corpo');
  if (apriRecesso && corpoRecesso) {
    apriRecesso.addEventListener('click', function () {
      corpoRecesso.removeAttribute('data-chiuso');
      apriRecesso.setAttribute('aria-expanded', 'true');
      apriRecesso.parentNode.hidden = true;
      var primo = $('input:not([type=hidden])', corpoRecesso);
      if (primo) primo.focus();
    });
  }

  /* ---------- ferma il movimento (piede): le animazioni infinite in pausa, le altre al loro arrivo, suoni in pausa ---------- */
  var fermate = [], bottoniFerma = $$('[data-ferma]'), annuncio = $('[data-pz-annuncio-pagina]');
  function annuncia(t) {
    if (!annuncio || !t) return;
    annuncio.textContent = '';
    setTimeout(function () { annuncio.textContent = t; }, 60);
  }
  function segnaFerma() {
    bottoniFerma.forEach(function (el) {
      el.setAttribute('aria-pressed', inPausa ? 'true' : 'false');
      var t = $('[data-ferma-testo]', el), nuovo = el.getAttribute(inPausa ? 'data-testo-riprendi' : 'data-testo-ferma');
      if (t && nuovo) t.textContent = nuovo;
    });
  }
  function fermaTutto(avvisa) {
    inPausa = true;
    html.classList.add('in-pausa');
    if (d.getAnimations) {
      d.getAnimations().forEach(function (a) {
        var tempi = a.effect && a.effect.getComputedTiming ? a.effect.getComputedTiming() : null;
        if (tempi && tempi.iterations === Infinity) {
          if (a.playState === 'running') { a.pause(); fermate.push(a); }
        } else if (a.playState === 'running') {
          try { a.finish(); } catch (e) {}
        }
      });
    }
    if (S) S.pausa();
    segnaFerma();
    if (avvisa && bottoniFerma[0]) annuncia(bottoniFerma[0].getAttribute('data-annuncio-fermo'));
  }
  function riparti() {
    inPausa = false;
    html.classList.remove('in-pausa');
    fermate.forEach(function (a) { try { a.play(); } catch (e) {} });
    fermate = [];
    if (S) S.riprendi();
    segnaFerma();
    if (bottoniFerma[0]) annuncia(bottoniFerma[0].getAttribute('data-annuncio-ripartito'));
  }
  bottoniFerma.forEach(function (el) {
    el.addEventListener('click', function () { if (inPausa) riparti(); else fermaTutto(true); });
  });

  /* ---------- resa (?resa): tutte le immagini subito, l'altezza della vista fissa ---------- */
  if (resa) {
    html.style.setProperty('--alto-resa', w.innerHeight + 'px');
    $$('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
  }

  /* =========================================================
     Rivelazioni a tempo, in tutti i browser: IntersectionObserver aggiunge .vista e la carta
     si alza, cade, si posa o si apre con la sua molla. Dove manca animation-timeline passano da qui
     anche i separatori, e la parallasse del diorama usa un solo ascoltatore di scorrimento.
     ========================================================= */
  if (!ridotto && !resa && 'IntersectionObserver' in w) {
    var daRivelare = '.titolo, .kit__tesoro, .tiro, .bundle, .passo, .tappa, .mini, .pezzo, .apertura, .bigliettino, .serve, .assaggio__comandi, .fonti__nota, .chiusa, .inverno__frase, .regole, .creatura, .cartellino, .tag__cartellino, .tavolo__pezzo, .pillole, .mensola, .busta, .pila' + (conTimeline ? '' : ', .taglia-qui');
    var vedi = function (voci, io) {
      voci.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('vista'); io.unobserve(x.target); } });
    };
    var ioVista = new IntersectionObserver(vedi, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    $$(daRivelare).forEach(function (el) { ioVista.observe(el); });
    // le carte piegate (biglietto, riquadro d'inverno) mostrano solo la piega: si aprono appena la piega entra in vista
    var ioPiega = new IntersectionObserver(vedi, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    $$('.biglietto, .inverno').forEach(function (el) { ioPiega.observe(el); });
    // l'assaggio della Bottega non parte nascosto (da fermo e senza JS si legge com'e'): .vista arriva un quarto di schermo
    // prima che entri, e la sua entrata parte dal primo fotogramma dell'animazione, fuori dallo schermo
    var ioPrima = new IntersectionObserver(vedi, { rootMargin: '0px 0px 25% 0px', threshold: 0 });
    $$('.pz-stanza').forEach(function (el) { ioPrima.observe(el); });

    var diorama = conTimeline ? null : $('.diorama');
    if (diorama) {
      var strati = [[$('.diorama__mappa', diorama), 14], [$('.diorama__luna', diorama), 30]], vivo = false, rq = 0;
      $$('.diorama__musone', diorama).forEach(function (el) { strati.push([el, 26]); });  // la nuvola e i suoi lampi insieme
      var muovi = function () {
        rq = 0;
        var r = diorama.getBoundingClientRect(), vh = w.innerHeight;
        var p = Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height))), s = p * 2 - 1;
        strati.forEach(function (x) { if (x[0]) x[0].style.translate = (x[0].classList.contains('diorama__musone') ? (s * 32).toFixed(1) + 'px ' : '0 ') + (s * x[1]).toFixed(1) + 'px'; });
      };
      new IntersectionObserver(function (v) { vivo = v[0].isIntersecting; if (vivo) muovi(); }).observe(diorama);
      w.addEventListener('scroll', function () { if (vivo && !rq) rq = requestAnimationFrame(muovi); }, { passive: true });
    }
  }
})();
